import React from 'react';
import Anchor from "../objects/Anchor";
import dateFormat from "dateformat";
import {dateHelpers as Date} from "../../../helpers";

const anchor = ( ctaText, ctaLink ) => {
    if( ctaText && ctaLink ){
        return <Anchor path={ ctaLink } anchorClass="theme-button" internal>{ ctaText }</Anchor>
    };
};

const StarsSection = props => {
    const { heading, bodyCopy, ctaText, ctaLink, id, expires } = props;

    return (
        <div className="`col-12 stars-section" id={`section-${id}`} data-aos>
            <h3 className="heading-three">{heading}</h3>
            <p className="body-copy">{bodyCopy}</p>
            {
                expires && Date.isDateLaterThanNow(expires) ?
                <span className="expires">{`Expires - ${dateFormat(expires, 'dd/mm/yyyy')}`}</span>
                : expires ? <span className="expires">Expired</span> : null
            }
            { anchor( ctaText, ctaLink ) }
        </div>
    );
};

export default StarsSection;



// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/StarsSection.js